(() => {
  'use strict';
  if (window.FXLFamilyCards) return;
  const selections = new Map();
  const familyKey = card => card.dataset.familyAxis + ':' + [...card.querySelectorAll('[data-family-option]')].map(option => option.dataset.optionId).sort().join(',');
  const currency = root => new Intl.NumberFormat(root.dataset.locale || 'nl-NL', {style:'currency',currency:root.dataset.currency || 'EUR'});
  const select = (option, money) => {
      if (!option) return;
      const card=option.closest('[data-family-card]');
      const data=option.dataset;
      if (!card || !data.optionUrl) return;
      if (card.dataset.selectedProductId===data.optionId) return;
      card.querySelectorAll('[data-family-option]').forEach(button=>button.setAttribute('aria-pressed',String(button===option)));
      card.dataset.selectedProductId=data.optionId;
      const context=card.closest('[data-family-context]');
      if(context) selections.set(context.dataset.familyContext+':'+familyKey(card),data.optionId);
      const heart=card.querySelector('[data-fxlf-save]');
      if (heart) {
        Object.assign(heart.dataset, {productId:data.optionId,handle:data.optionHandle,title:data.optionTitle,image:data.optionImage || '',variantId:data.optionVariantId || ''});
        window.FXLFeestlijsten?.scanHearts(heart);
      }
      if(card.dataset.familyAxis!=='content'){const choices=[...card.querySelectorAll('[data-family-option]')];const shown=new Set([option,...choices.filter(button=>button!==option).slice(0,4)]);choices.forEach(button=>{button.hidden=!shown.has(button);});}
      const stock=card.querySelector('[data-family-stock-current]');
      const stockTemplate=[...card.querySelectorAll('template[data-family-stock]')].find(template=>template.dataset.familyStock===data.optionId);
      if (stock && stockTemplate) stock.replaceChildren(stockTemplate.content.cloneNode(true));
      const purchase=card.querySelector('[data-family-purchase-current]');
      const purchaseTemplate=[...card.querySelectorAll('template[data-family-purchase]')].find(template=>template.dataset.familyPurchase===data.optionId);
      if (purchase && purchaseTemplate) {
        const previousQuantity=Number(purchase.querySelector('[name="quantity"]')?.value);
        if (purchaseTemplate.hasAttribute('data-single-variant')) {
          const details=purchaseTemplate.dataset;
          const form=card.querySelector('[data-family-default-form]').content.querySelector('form').cloneNode(true);
          const input=form.elements.quantity,button=form.querySelector('[type="submit"]');
          form.elements.id.value=details.variantId;
          form.dataset.addLabel=details.addLabel;button.setAttribute('aria-label',details.addLabel);
          input.min=details.min;input.step=details.step;input.max=details.max;input.value=details.min;
          input.disabled=button.disabled=details.available!=='true'||Number(details.max)<Number(details.min);
          purchase.replaceChildren(purchaseTemplate.content.cloneNode(true),form);
        } else purchase.replaceChildren(purchaseTemplate.content.cloneNode(true));
        const field=purchase.querySelector('[name="quantity"]');
        if (field && !field.disabled) {
          const min=Number(field.min)||1,step=Number(field.step)||1,max=Number(field.max);
          if (previousQuantity>=min && previousQuantity<=max && (previousQuantity-min)%step===0) field.value=String(previousQuantity);
          field.dispatchEvent(new Event('input',{bubbles:true}));
        }
      }
      card.querySelector('[data-family-price]').textContent=money.format(Number(data.optionPrice)/100);
      card.querySelector('[data-family-from]').hidden=data.optionPriceVaries!=='true';
      const imageLink=card.querySelector('.fxl-product-card__image');
      const titleLink=card.querySelector('[data-family-title]');
      const chooseLink=card.querySelector('.fxl-product-card__choose');
      [imageLink,titleLink].forEach(link=>{ link.href=data.optionUrl; });
      const familyURL=data.optionUrl+(card.dataset.familyAnchor || '');
      chooseLink.href=familyURL;
      const moreLink=card.querySelector('[data-family-more]');
      if (moreLink) moreLink.href=familyURL;
      titleLink.textContent=data.optionTitle;
      imageLink.setAttribute('aria-label',data.optionTitle);
      titleLink.setAttribute('aria-label',data.optionTitle);
      chooseLink.setAttribute('aria-label',`${chooseLink.textContent.trim()}: ${data.optionTitle}`);
      let image=imageLink.querySelector('img');
      if (data.optionImage) {
        if (!image) {
          image=document.createElement('img'); image.loading='lazy';
          image.sizes='(max-width: 760px) 45vw, (max-width: 1100px) 30vw, 250px';
          image.width=640; image.height=640; imageLink.prepend(image);
        }
        image.alt=data.optionTitle;
        image.srcset=data.optionSrcset || '';
        image.src=data.optionImage;
      }
      if (image) image.hidden=!data.optionImage;
      const placeholder=imageLink.querySelector('[data-family-placeholder]');
      if (placeholder) placeholder.hidden=Boolean(data.optionImage);
  };
  const restore = root => {
    if (!root?.dataset.familyContext) return;
    root.querySelectorAll('[data-family-card]').forEach(card => {
      const selected = selections.get(root.dataset.familyContext+':'+familyKey(card));
      const option = [...card.querySelectorAll('[data-family-option]')].find(button => button.dataset.optionId === selected);
      if (option) select(option,currency(root));
    });
  };
  document.addEventListener('change',event=>{
    const selector=event.target.closest('[data-family-variant]');
    if (!selector) return;
    const option=selector.selectedOptions[0],form=selector.form,card=selector.closest('[data-family-card]');
    const field=form.elements.quantity,button=form.querySelector('[type="submit"]');
    const available=Boolean(option.value)&&!option.disabled;
    button.disabled=!available;
    field.disabled=!available;
    if (!available) return;
    field.min=option.dataset.min;field.step=option.dataset.step;field.max=option.dataset.max;
    field.value=option.dataset.min;field.setCustomValidity('');
    card.querySelector('[data-family-price]').textContent=currency(card.closest('[data-family-context]')||card).format(Number(option.dataset.price)/100);
    card.querySelector('[data-family-from]').hidden=true;
    const stockTemplate=[...form.querySelectorAll('[data-family-variant-stock]')].find(template=>template.dataset.familyVariantStock===option.value);
    if (stockTemplate) card.querySelector('[data-family-stock-current]').replaceChildren(stockTemplate.content.cloneNode(true));
    const heart=card.querySelector('[data-fxlf-save]');
    if (heart) {heart.dataset.variantId=option.value;window.FXLFeestlijsten?.scanHearts(heart);}
    field.dispatchEvent(new Event('input',{bubbles:true}));
  });
  window.FXLFamilyCards = {select,restore};
  document.addEventListener('click', event => {
    const option = event.target.closest('[data-family-option]');
    const series = option?.closest('[data-fxlp-series],[data-family-context]');
    if (!series) return;
    event.preventDefault();
    const money = currency(series);
    select(option, money);
  });
})();

